import { getMeta } from '@precon-tools-suite-by-shared/browser-utils';

export function getScope(serviceIdentifier: string, scope: string): string {
    if (serviceIdentifier === 'PreconBackend') {
        serviceIdentifier =
            getMeta('b2c-backend-identifier-uri') ?? serviceIdentifier;
    }

    return serviceIdentifier + '/' + scope;
}

export function getScopes(services: Record<string, string[]>): string[] {
    return Object.entries(services).flatMap(([service, scopes]) =>
        scopes.map((scope) => getScope(service, scope))
    );
}
